/**
 * AccionesProducto — más barato, promoción, más margen (con costo), otra forma y dosis por peso.
 * 2026-10-21 (lienzo "la decisión primero", aprobado por Elvio): van dentro de la tarjeta del producto
 * de la última respuesta, no al pie de la conversación. Las resuelve el código, sin modelo.
 */
import { useState } from 'react'
import type { ProductCard } from '../types/product_card'
import type { AccionCaso } from '../api/accion'

interface Props {
  card?: ProductCard
  perfil: string | null
  ocupado: boolean
  onAccion: (accion: AccionCaso, extra?: { forma?: string; peso_kg?: number }) => void
}

export function AccionesProducto({ card, perfil, ocupado, onAccion }: Props) {
  const [peso, setPeso] = useState('')
  if (!card?.sku_id) return null
  // 20-oct: una crema o pasta (paspadura) no tiene dosis por peso; solo lo que se toma con dosis
  const pediatrico = !!card.dosis_por_peso || (!!perfil?.startsWith('child') && !!card.dosis
    && !['crema', 'gel', 'colirio', 'óvulo', 'spray'].includes(String(card.forma ?? '')))
  const pesoNum = Number(peso.replace(',', '.'))
  const pesoValido = pesoNum >= 2 && pesoNum <= 150

  return (
    <div className="cierre-acciones" role="group" aria-label="Acciones sobre este producto">
      <button type="button" className="accion" disabled={ocupado} onClick={() => onAccion('mas_barato')}>
        Más barato
      </button>
      <button type="button" className="accion" disabled={ocupado} onClick={() => onAccion('promocion')}>
        Promoción
      </button>
      {card.margen_disponible && (
        <button type="button" className="accion" disabled={ocupado} onClick={() => onAccion('margen')}>
          Más margen
        </button>
      )}
      <button type="button" className="accion" disabled={ocupado} onClick={() => onAccion('otra_forma')}>
        Otra forma
      </button>
      {pediatrico && (
        <form
          className="accion accion-peso"
          onSubmit={(e) => {
            e.preventDefault()
            if (pesoValido && !ocupado) onAccion('dosis_peso', { peso_kg: pesoNum })
          }}
        >
          <label htmlFor="peso-caso">Dosis por peso</label>
          <input
            id="peso-caso"
            inputMode="decimal"
            placeholder="kg"
            value={peso}
            onChange={(e) => setPeso(e.target.value.replace(/[^\d.,]/g, '').slice(0, 5))}
            aria-label="Peso del paciente en kilos"
          />
          <button type="submit" disabled={!pesoValido || ocupado}>Calcular</button>
        </form>
      )}
    </div>
  )
}
